import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Retrospective } from "../../interfaces/retrospective";
import { Router } from "@angular/router";

@Injectable()
export class RetrospectiveService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  async getByProjectId(projectId): Promise<Retrospective[]> {
    try {
      let params = new HttpParams().set("projectId", projectId);
      let response = await this.http
        .get<any>(this.env.managirUrl + "/retrospectives", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise();
      return response.RetrospectiveResponse.retrospectives;
    } catch (error) {
      if (error.status === 404 || error.status === 403) {
        this.router.navigate(["/" + error.status]);
      }
    }
  }

  async getByShortId(shortId): Promise<Retrospective> {
    try {
      let params = new HttpParams().set("shortId", shortId);
      let response = await this.http
        .get<any>(this.env.managirUrl + "/retrospectives", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise();
      return response.RetrospectiveResponse.retrospectives[0];
    } catch (error) {
      if (error.status === 404 || error.status === 403) {
        this.router.navigate(["/" + error.status]);
      }
    }
  }

  async create(retrospective: Retrospective): Promise<Retrospective> {
    let response = await this.http
      .post<any>(this.env.managirUrl + "/retrospectives", retrospective, {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
    return response.RetrospectiveResponse.retrospectives[0];
  }

  async save(retrospective: Retrospective): Promise<Retrospective> {
    let response = await this.http
      .put<any>(
        this.env.managirUrl + "/retrospectives/" + retrospective._id,
        retrospective,
        { headers: { "Content-Type": "application/json" } }
      )
      .toPromise();
    return response.RetrospectiveResponse.retrospectives[0];
  }

  async delete(retrospectiveId: string): Promise<string> {
    let response = await this.http
      .delete<any>(this.env.managirUrl + "/retrospectives/" + retrospectiveId, {
        headers: { "Content-Type": "application/json" },
      })
      .toPromise();
    return response.message;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/retrospective/retrospective.service.ts